import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  getProfileSuccess,
  getProfileFailure,
  updateProfileFailure,
  changePasswordFailure,
  updateProfileSuccess,
} from "../../actions";
import {
  GET_PROFILE,
  UPDATE_PROFILE_DATA,
  CHANGE_PASSWORD,
} from "../../Actions/types";
import api from "../../../helper/api";

function* fetchGetProfile(actions) {
  try {
    const response = yield api.get(`/admin/getProfile`);
    if (response?.data?.code === 200) {
      yield put(getProfileSuccess({ getData: response?.data?.data }));
      yield call(actions?.payload?.callback, response?.data?.data);
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getProfileFailure({ getError: e }));
  }
}

function* fetchUpdateProfile(actions) {
  const formData = {
    firstName: actions?.payload?.form?.firstName,
    lastName: actions?.payload?.form?.lastName,
    image: actions?.payload?.form?.image,
    email: actions?.payload?.form?.emailAddress
  };
  try {
    const response = yield api.put(
      `/admin/editProfile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield put(updateProfileSuccess({ updateData: response?.data?.data }));
      yield call(actions?.payload?.callback, response?.data?.data);
    } else if (response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateProfileFailure({ updateError: e }));
  }
}

function* fetchChangePassword(actions) {
  try {
    const response = yield api.put(
      "/admin/changePassword",
      actions?.payload?.formData
    );
    if (response?.data?.code === 200) {
      toast.success(`${response?.data?.message} You have to login again!`);
      yield call(actions?.payload?.callback, response?.data);
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(changePasswordFailure({ error: e }));
  }
}

function* getProfileWatcher() {
  yield takeLatest(GET_PROFILE, fetchGetProfile);
}

function* updateProfileWatcher() {
  yield takeLatest(UPDATE_PROFILE_DATA, fetchUpdateProfile);
}

function* changePasswordWatcher() {
  yield takeLatest(CHANGE_PASSWORD, fetchChangePassword);
}

export default function* profileSaga() {
  yield all([
    getProfileWatcher(),
    updateProfileWatcher(),
    changePasswordWatcher(),
  ]);
}
